import { combineReducers } from 'redux';

import dashboard from '../individualPortal/dashboard/dashboardReducer';
import applications from './applications/applicationsReducer';
import communicationPreferences, * as fromCommunicationPreferences
    from './communicationPreferences/communicationPreferencesReducer';
import eligibilityResults from './eligibilityResults/eligibilityResultsReducer';
import ticket from '../individualPortal/ticket/ticketReducer';
import ticketFile from '../individualPortal/ticket/ticketFileReducer';
import secureInbox from '../individualPortal/secureInbox/secureInboxReducer';
import customGrouping from './customGrouping/customGroupingReducer';
import enrollmentHistory from './enrollmentHistory/enrollmentHistoryReducer';
import planSummary from './planSummary/planSummaryReducer';

export default combineReducers({
    dashboard,
    applications,
    communicationPreferences,
    eligibilityResults,
    secureInbox,
    ticket,
    ticketFile,
    customGrouping,
    enrollmentHistory,
    planSummary,
});

// Selectors

export const selectMailingAddressFromComPref =
    state => fromCommunicationPreferences.selectMailingAddressFromComPref(state.communicationPreferences);
export const selectIfCommunicationPreferencesLoaded =
    state => fromCommunicationPreferences.selectIfCommunicationPreferencesLoaded(state.communicationPreferences);
export const selectCommunicationPreferences = state => state.communicationPreferences;